import React, { useContext } from "react";
import { UserContext } from "../../context/UserContext";
import RecentActorsIcon from "@mui/icons-material/RecentActors";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import "react-toastify/dist/ReactToastify.css";
import "./HeaderStyles.css";
import { showToast } from "../../util/showToast";

const RoleImpersonation = () => {
    const { user, setUser } = useContext(UserContext);

    const impersonateUser = (roleId) => {
        switch (roleId) {
            case 1:
                return "Bioinformatics";
            case 2:
                return "Biologist";
            case 3:
                return "Plan Approver";
            case 4:
                return "Biorepository Operations";
            case 5:
                return "Data Collaboration Team";
            case 0:
                return "Default User";
            default:
                return "Admin";
        }
    }

    const handleRoleChange = (newRoleId) => {
        if (user.roleId === 100) {
            const updatedUser = { ...user, selectedRoleId: newRoleId };
            setUser(updatedUser);
            showToast(`Switch to ${impersonateUser(newRoleId)}.`, <RecentActorsIcon style={{ color: "#2155bc" }} />);
        }
    };

    const revertToAdmin = () => {
        if (user.roleId === 100) {
            const updatedUser = { ...user, selectedRoleId: 100 };
            setUser(updatedUser);
            showToast("Reset to Admin.", <RecentActorsIcon style={{ color: "#2155bc" }} />);
        }
    };

    return (
        <div className="roleImpersonation">
            {user.roleId === 100 && (
                <div className="roleImpersonationSelection">
                    <RecentActorsIcon />
                    <select
                        value={user.selectedRoleId.toString()}
                        onChange={(e) => handleRoleChange(parseInt(e.target.value))}
                        id="roleImpersonationSelectionField"
                    >
                        <option value="100" disabled selected hidden>Impersonate As:</option>
                        <option value="1">Bioinformatics&nbsp;&nbsp;</option>
                        <option value="2">Biologist&nbsp;&nbsp;</option>
                        <option value="3">Plan Approver&nbsp;&nbsp;</option>
                        <option value="4">Biorepository Operations&nbsp;&nbsp;</option>
                        <option value="5">Data Collaboration Team&nbsp;&nbsp;</option>
                        <option value="0">Default User&nbsp;&nbsp;</option>
                    </select>
                </div>
            )}
            {user.roleId === 100 && user.selectedRoleId !== 100 && (
                <a className="roleImpersonationClear" onClick={revertToAdmin}>
                    <RestartAltIcon style={{ fontSize: "18px" }} />
                </a>
            )}
        </div>
    );
};

export default RoleImpersonation;
